import { render } from "./BedSvg.vue?vue&type=template&id=6dfdf4b2"
import script from "./BedSvg.vue?vue&type=script&lang=js"
export * from "./BedSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__